import React from "react";
import "./PickupSection.css";

const formatAddress = (order) => [
    order.fulfillment_address,
    order.fulfillment_city,
    order.fulfillment_state,
    order.fulfillment_zip_code,
].filter(Boolean).join(", ");

// Read-only pickup/delivery address and historical handoff context. Order
// completion for pickup/delivery orders now happens through the same unified
// buyer action (packaging photo + signed Chain of Custody upload) used by
// carrier shipping — see ReceiptUpload / POST /orders/:id/receive.
const PickupSection = ({ order, photos }) => {
    const isPickup = order.fulfillment_method === "buyer_pickup";
    const contactName = order.seller_contact_name || order.seller_company || "the seller";

    return (
        <div className="pickup-section">
            <h4 className="pickup-section__title">{isPickup ? "Buyer Pickup" : "Personal Delivery"}</h4>
            <div className="pickup-section__address">
                <span className="pickup-section__eyebrow">{isPickup ? "Pickup address" : "Delivery address"}</span>
                <strong>{formatAddress(order) || "Address unavailable"}</strong>
            </div>
            {order.user_role !== "seller" && (
                <p className="pickup-section__guidance">
                    To organise a specific date and time for {isPickup ? "pickup" : "delivery"}, contact {contactName}
                    {order.seller_contact_email ? (
                        <> at <a href={`mailto:${order.seller_contact_email}`}>{order.seller_contact_email}</a>.</>
                    ) : "."}
                </p>
            )}
            {(order.seller_handoff_person_name || order.buyer_handoff_person_name) && (
                <div className="pickup-section__confirmations">
                    {order.seller_handoff_person_name && (
                        <span className="is-confirmed">Seller recorded handoff to {order.seller_handoff_person_name}</span>
                    )}
                    {order.buyer_handoff_person_name && (
                        <span className="is-confirmed">Buyer recorded receipt from {order.buyer_handoff_person_name}</span>
                    )}
                </div>
            )}
            {photos?.length > 0 && (
                <div className="pickup-section__photos">
                    {photos.map((photo) => <img key={photo.id} src={photo.s3_url} alt={`${isPickup ? "Pickup" : "Delivery"} handoff evidence`} />)}
                </div>
            )}
        </div>
    );
};

export default PickupSection;
